import React, { useState, useEffect } from "react";
import treepic from "../assets/img/member-tree.png";
import { ITreasureContract } from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import { FaCheck } from "react-icons/fa";
import Loader from "./Loader";

/* ---------------------------------------------------
   TREE NODE COMPONENT
--------------------------------------------------- */
const TreeNode = ({ node, onExpand }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const maskWallet = (addr) =>
    addr ? addr.substring(0, 2) + "****" + addr.substring(addr.length - 2) : "";

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(node.wallet);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const handleToggle = async () => {
    if (!open) {
      await onExpand(node);      // fetch children for THIS NODE only
    }
    setOpen((prev) => !prev);
  };

  return (
    <li className={open ? "open" : ""}>
      <a className="member" onClick={handleToggle} style={{ cursor: "pointer" }}>
        <div className="member-div">
          <span className="member-icon">
            <img src={treepic} alt="member" />
          </span>

          {/* ONLY show arrow if actual children exist */}
          {node.children?.length > 0 && (
            <span className="dropdown-arrow">
              <i className="fa-solid fa-chevron-down"></i>
            </span>
          )}
        </div>

        <div className="member-name-div">{node.name || "User"}</div>

        <div className="wallet-container">
          <span className="wallet">{maskWallet(node.wallet)}</span>
          <button className="copy-btn" onClick={handleCopy}>
            {!copied ? (
              <span className="icon">
                <i className="fa-regular fa-copy"></i>
              </span>
            ) : (
              <span className="check">
                <i className="fa-solid fa-check"></i>
              </span>
            )}
          </button>
        </div>
      </a>

      {/* Expand children */}
      {open && (
        <ul>
          {node.children?.length > 0 ? (
            node.children.map((child, i) => (
              <TreeNode key={i} node={child} onExpand={onExpand} />
            ))
          ) : (
            <li className="text-light ms-3" style={{ fontSize: "13px" }}>
              No Downline
            </li>
          )}
        </ul>
      )}
    </li>
  );
};

/* ---------------------------------------------------
   MAIN MLM TREE
--------------------------------------------------- */
const MLMTree = ({ address, web3 }) => {
  const [activePackage, setActivePackage] = useState(0);
  const [treeData, setTreeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const packageList = [
    { id: 0, price: "$10" },
    { id: 1, price: "$20" },
    { id: 2, price: "$50" },
    { id: 3, price: "$100" },
    { id: 4, price: "$200" },
    { id: 5, price: "$400" },
    { id: 6, price: "$600" },
    { id: 7, price: "$1000" },
    { id: 8, price: "$1500" },
  ];

  /* ---------------------------------------------------
     Fetch a specific level for SPECIFIC node only
  --------------------------------------------------- */
  const fetchLevelData = async (rootWallet, packageId) => {
  if (!web3 || !rootWallet) return [];

  try {
    const instance = new web3.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

    // Always fetch FIRST LEVEL of the clicked user
    const users = await instance.methods
      .getFetchLevel(rootWallet, packageId, 0)
      .call();

    return users.map((addr) => ({
      name: addr.slice(0, 4) + "***" + addr.slice(-4),
      wallet: addr,
      level: 0,
      children: [],
    }));
  } catch (error) {
    console.error("Error Fetching Level:", error);
    return [];
  }
};


  /* ---------------------------------------------------
      Load Root Node (User at Top)
  --------------------------------------------------- */
  const fetchRootData = async () => {
    setIsLoading(true);
    try {
      const level0 = await fetchLevelData(activePackage, 0);

      setTreeData([
        {
          name: address.slice(0, 4) + "***" + address.slice(-4),
          wallet: address,
          level: 0,
          children: level0,
        },
      ]);
    } catch (err) {
      console.error("Root Load Error:", err);
    }
    setIsLoading(false);
  };

  /* ---------------------------------------------------
     Expand only THIS NODE — prevent wrong binding
  --------------------------------------------------- */
  const handleExpand = async (node) => {
  try {
    if (node.childrenLoaded) return;

    // Fetch user’s OWN downline only
    const children = await fetchLevelData(node.wallet, activePackage);

    node.children = children;
    node.childrenLoaded = true;

    setTreeData([...treeData]);
  } catch (err) {
    console.error("Expand Error:", err);
  }
};


  /* ---------------------------------------------------
      REFRESH ON PACKAGE CHANGE
  --------------------------------------------------- */
  useEffect(() => {
    if (address && web3) {
      fetchRootData();
    }
  }, [activePackage, address, web3]);

  return (
    <section className="networking-section">
      <div className="row">
        <div className="col-md-12">
          <div className="card-tree">
            <h4 className="text-white">
              <span className="text-warning"> Level </span>
              <span className="fw-lighter"> Tree </span>
            </h4>

            <div className="ultree-tabs-div">
              <ul className="ultree-tabs">
                {packageList.map((pkg) => (
                  <li
                    key={pkg.id}
                    onClick={() => setActivePackage(pkg.id)}
                    className={pkg.id === activePackage ? "active" : ""}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    {pkg.id === activePackage && (
                      <FaCheck style={{ fontSize: "12px" }} />
                    )}
                    {pkg.price}
                  </li>
                ))}
              </ul>
            </div>

            {isLoading ? (
              <div className="Loadermlm">
                <Loader />
              </div>
            ) : (
              <div className="tree">
                <div className="treeinner">
                      <ul>
                  {treeData.length > 0 ? (
                    treeData.map((node, i) => (
                      <TreeNode key={i} node={node} onExpand={handleExpand} />
                    ))
                  ) : (
                    <p className="mb-2 text-light">
                      No Users Found For This Package Yet.
                    </p>
                  )}
                </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MLMTree;
